import { MetadataHandler } from '@/app/shared/components/MetadataHandler';
import Home from './Home';

export const HomeRedirect = () => {

  return (
    <MetadataHandler>
      <Home />
    </MetadataHandler>
  );
};